module.exports = __webpack_public_path__ + "img/nbus_footer_text.ecbceed3.png";